// Importing React and external libs
import React from 'react';

// Importing assets
import './style.scss';

export const REFERENCE_COLORS = {
  SIBLING: ['blue', 'orange'],
  PATERNAL: ['blue', '#e5e5e5'],
  MATERNAL: ['#e5e5e5', 'orange'],
};

const Reference = ({ height = '1.5em', lowerColor = 'orange', upperColor = 'blue' }) => {
  return (
    <div className='reference'>
      <div style={{ height, backgroundColor: upperColor  }}></div>
      <div style={{ height, backgroundColor: lowerColor  }}></div>
    </div>
  );
};

export default Reference;